(function () {
  var room = document.querySelector('[data-v3-room]');
  if (!room) return;
  var mat = room.querySelector('[data-v3-mat]');
  var index = room.querySelector('[data-v3-index]');
  var peek = room.querySelector('[data-v3-peek]');
  var peekImg = peek ? peek.querySelector('img') : null;
  var buttons = room.querySelectorAll('[data-v3-mode]');

  function setMode(mode) {
    if (!mat || !index) return;
    mat.hidden = mode !== 'table';
    index.hidden = mode !== 'index';
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v3-mode') === mode)); });
    try { sessionStorage.setItem('v3-mode', mode); } catch (e) {}
  }
  buttons.forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-v3-mode')); }); });
  var saved = null; try { saved = sessionStorage.getItem('v3-mode'); } catch (e) {}
  if (saved === 'index') setMode('index');

  // intro: each name tape presses onto its piece as it scrolls into view
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cells = room.querySelectorAll('.v3-cell');
  if (!reduce && 'IntersectionObserver' in window && cells.length) {
    room.classList.add('v3-anim');
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.setProperty('--d', (n++ * 0.12 + 0.15) + 's');
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.35 });
    cells.forEach(function (c) { io.observe(c); });
  }

  // pick things up and move them (desktop mouse only)
  var canDrag = window.matchMedia('(min-width: 750px) and (pointer: fine)');
  var z = 10;
  room.querySelectorAll('[data-v3-drag]').forEach(function (el) {
    var start = null, moved = false, dx = 0, dy = 0;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (!canDrag.matches || e.button !== 0) return;
      start = { x: e.clientX - dx, y: e.clientY - dy, sx: e.clientX, sy: e.clientY };
      moved = false;
      el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function (e) {
      if (!start) return;
      if (!moved && Math.abs(e.clientX - start.sx) + Math.abs(e.clientY - start.sy) < 6) return;
      if (!moved) { moved = true; el.classList.add('is-dragging'); var host = el.closest('.v3-cell') || el; host.style.zIndex = ++z; }
      dx = e.clientX - start.x; dy = e.clientY - start.y;
      el.style.setProperty('--dx', dx + 'px');
      el.style.setProperty('--dy', dy + 'px');
    });
    function end() { start = null; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
  });

  // index: the piece appears beside the cursor
  if (index && peek && peekImg) {
    index.querySelectorAll('a[data-img]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { peekImg.src = a.getAttribute('data-img'); peek.hidden = false; });
      a.addEventListener('mouseleave', function () { peek.hidden = true; });
      a.addEventListener('mousemove', function (e) { peek.style.left = e.clientX + 'px'; peek.style.top = e.clientY + 'px'; });
    });
  }
})();
